import { render, staticRenderFns } from "./TagMenuList.vue?vue&type=template&id=5332dd98&scoped=true"
import script from "./TagMenuList.vue?vue&type=script&lang=js"
export * from "./TagMenuList.vue?vue&type=script&lang=js"
import style0 from "./TagMenuList.vue?vue&type=style&index=0&id=5332dd98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5332dd98",
  null
  
)

export default component.exports